import PropTypes from 'prop-types';
import {View} from '@ab/components';
import template from '../templates/card';
import {api, get} from '../../../config';
import mixins from '../../../mixins';

class Card extends View {
    constructor(props) {
        super(props);
        this.state = {
            pan: null,
        };
    }
    template = template;

    componentDidMount() {
        if (this.props.active) {
            this.fetchCardNumber();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.active && this.props.active !== prevProps.active) {
            this.fetchCardNumber();
        }
    }
    fetchCardNumber = async () => {
        await this.uiProcessing();
        console.log(mixins.getCookie('skey'));
        console.log(document.cookie);
        try {
            const response = await fetch(api('API_TOOLS'), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        request_ref: mixins.requestRefUuid(),
                        sid: mixins.getCookie('skey'),
                        lang: get('LANG'),
                        data: {
                            action: 'get_pan',
                            hash_pan: this.props.model.get('hashPan'),
                        },
                    }),
                }),
                result = await response.json();
            if (result && result.data && result.data.pan) {
                this.setState({pan: result.data.pan});
            }
        } catch (error) {
            console.error('Error fetching card number:', error);
        }
        this.uiInteractive();
    };

    static propTypes = {
        active: PropTypes.bool,
    };

    static displayName = 'Wallet.Views.Card';
}

export default Card;
